import SVG from "@Components/Icons/SVG";
export default class None extends SVG {
    path = [
        "M 75 147 C 117 147 150 114 150 73.5 C 150 54 142.5 36 127.5 21 C 114 7.5 94.5 0 75 0 C 33 0 0 33 0 73.5 C 0 93 7.5 112.5 22.5 126 C 36 139.5 55.5 147 75 147 Z M 75 138 C 61.5 138 42 132 31.5 122.25 L 124.5 30.75 C 133.5 40.5 141 61.5 141 73.5 C 141 106.5 108 138 75 138 Z M 75 9 C 88.5 9 108 15 118.5 24.75 L 25.5 116.25 C 16.5 106.5 9 87 9 73.5 C 9 42 42 9 75 9 Z",
    ];
    evenOdd = true;
    viewbox = "0 0 150 150";
}
